import { combineReducers } from 'redux'
import currentSiteReducer from './currentSite'
import sitesReducer from './sites'

export default combineReducers({
  currentSite: currentSiteReducer,
  list: sitesReducer,
})



// WEBPACK FOOTER //
// ./src/modules/sites/reducers/index.js